export default __webpack_public_path__ + "static/media/iai_half.44bee7fc.png";